import React, { Suspense, lazy } from 'react';
import ReactOnRails from 'react-on-rails/client';

// Eager: used on most pages (header/footer) or very small.
import Header from 'bundles/Aplication/components/Header';
import Printed from 'bundles/Components/Printed';

const lazyComponent = (Component) => (props) =>
  React.createElement(
    Suspense,
    {
      fallback: React.createElement('div', {
        className: 'loading-placeholder',
        style: { minHeight: '100px' },
      }),
    },
    React.createElement(Component, props)
  );

// Lazy: pulls in third-party SDKs or page-specific code only when mounted.
const LoadGoogleAd = lazy(() => import('bundles/Aplication/components/LoadGoogleAd'));
const RenderSuperBlock = lazy(() => import('bundles/Components/RenderSuperBlock'));

const CommerceSlides = lazy(() => import('bundles/Commerce/CommerceSlides'));
const GrandstandVoice = lazy(() => import('bundles/Components/GrandstandVoice'));
const GrandstandVideo = lazy(() => import('bundles/Components/GrandstandVideo'));
const Galery = lazy(() => import('bundles/Components/Galery'));
const VideoPlayer = lazy(() => import('bundles/Components/VideoPlayer'));
const OttHeader = lazy(() => import('bundles/Components/ott/OttHeader'));
const StreamingHeader = lazy(() => import('bundles/Components/ott/StreamingHeader'));
const Playlist = lazy(() => import('bundles/Components/Playlist'));
const Share = lazy(() => import('bundles/Components/Share'));
const ShowMore = lazy(() => import('bundles/Components/ShowMore'));

const GoogleMapsApi = lazy(() => import('bundles/Components/GoogleMapsApi'));
const CountrySelect = lazy(() => import('bundles/Components/CountrySelect'));
const StateSelect = lazy(() => import('bundles/Components/StateSelect'));
const StripeCheckout = lazy(() => import('bundles/Components/StripeCheckout'));
const CategoriesModal = lazy(() => import('bundles/Events/components/CategoriesModal'));
const DateModal = lazy(() => import('bundles/Components/DateModal'));
const EventCategories = lazy(() => import('bundles/Events/components/EventCategories'));
const ChessFields = lazy(() => import('bundles/Components/ChessFields'));
const FileUpload = lazy(() => import('bundles/Components/FileUpload'));

ReactOnRails.register({
  Header,
  Printed,

  LoadGoogleAd: lazyComponent(LoadGoogleAd),
  RenderSuperBlock: lazyComponent(RenderSuperBlock),

  CommerceSlides: lazyComponent(CommerceSlides),
  GrandstandVoice: lazyComponent(GrandstandVoice),
  GrandstandVideo: lazyComponent(GrandstandVideo),
  Galery: lazyComponent(Galery),
  VideoPlayer: lazyComponent(VideoPlayer),
  OttHeader: lazyComponent(OttHeader),
  StreamingHeader: lazyComponent(StreamingHeader),
  Playlist: lazyComponent(Playlist),
  Share: lazyComponent(Share),
  ShowMore: lazyComponent(ShowMore),
  GoogleMapsApi: lazyComponent(GoogleMapsApi),
  CountrySelect: lazyComponent(CountrySelect),
  StateSelect: lazyComponent(StateSelect),
  StripeCheckout: lazyComponent(StripeCheckout),
  CategoriesModal: lazyComponent(CategoriesModal),
  DateModal: lazyComponent(DateModal),
  EventCategories: lazyComponent(EventCategories),
  ChessFields: lazyComponent(ChessFields),
  FileUpload: lazyComponent(FileUpload),
});
